

import { Checkbox, FormControlLabel } from '@material-ui/core';
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined } from '@material-ui/icons';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from 'semantic-ui-react';
import './flights.css';
import { FlightsFilter } from './flightsFilters';
import { sortFlightList, resetFlightPage, updateFlightDataItem, filterByNonStop, filterByStops, clearNonStop } from './services/Flights.slice';
import { getFlightsListThunk } from './services/Flights.thunks';
import { useLocation } from 'react-router-dom';


export const FlightSortComponent = ({ is_mobile }) => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const preselectedStops = queryParams.get('stops'); // e.g. "1,2" for Non-Stop and 1-Stop


    const [selectedType, setType] = React.useState('Best')
    const [selectNonStop, setNonStop] = React.useState(false)
    const initalStops = [{
        name: 'Non-Stop',
        value: 1,
        show: true,
        disabled: false
    }, {
        name: '1-Stop',
        value: 2,
        show: true
    }, {
        name: '2+Stop',
        value: 3,
        show: true
    }];

    const [stops, setStops] = React.useState(initalStops)
    const [hasNonStop, setHasNonstop] = React.useState(false)
    const flights = useSelector(state => state.Flights);
    const searchData = useSelector(state => state.Flights.searchData);
    const flightData = useSelector(state => state.Flights.flightData);
    const loading = useSelector(state => state.Flights.loading);
    const reachedEnd = useSelector(state => state.Flights.reachedEnd);
    const didApplyFilters = React.useRef(false);



    React.useEffect(() => {
        if (flights.flightListData.length > 0 && !didApplyFilters.current) {
            applyUrlFilters();
            didApplyFilters.current = true; // ✅ prevent future runs
        }
    }, [flights.flightListData]);

    // Separate effect to handle non-stop availability check
    React.useEffect(() => {
        if (flights.flightListData.length > 0) {
            const hasNonStop = checkNonstop(flights);
            console.log('Non-stop availability check:', { hasNonStop, flightCount: flights.flightListData.length });
            setHasNonstop(hasNonStop);

            // Always update the disabled state based on actual availability
            setStops(prev => {
                const newValues = [...prev];
                newValues[0].disabled = !hasNonStop;
                console.log('Updated stops state:', { disabled: newValues[0].disabled, hasNonStop });
                return newValues;
            });
        }
    }, [flights.flightListData]);





    const applyUrlFilters = () => {
        const stopsParam = queryParams.get('stops'); // e.g. "0,1,2"
        const sortParam = queryParams.get('sort');   // e.g. "Cheapest"

        const stopIndexes = stopsParam?.split(',').map(Number).filter(n => !isNaN(n)) || [];
        // Apply stop filters
        if (stopIndexes.length > 0) {
            setStops(prev => {
                const updated = [...prev];
                updated.forEach((stop, i) => {
                    stop.show = stopIndexes.includes(i);
                });

                const onlyNonStop = stopIndexes.length === 1 && stopIndexes[0] === 0;
                setNonStop(onlyNonStop);

                if (onlyNonStop) {
                    dispatch(filterByNonStop());
                } else {
                    stopIndexes.forEach(i => {
                        if (i !== 0 && updated[i]) {
                            dispatch(filterByStops(Number(updated[i].value) + 1));
                        }
                    });
                }

                // Preserve the disabled state for non-stop based on availability
                // Don't override the disabled state set by the non-stop availability check
                return updated;
            });
        }

        // Apply sort filter
        if (sortParam && flightType.includes(sortParam)) {
            setType(sortParam);
            dispatch(sortFlightList(sortParam));
        } else {
            dispatch(sortFlightList(selectedType)); // fallback
        }
    };


    //apply filters persistent
    React.useEffect(() => {
        if (selectNonStop) {
            dispatch(filterByNonStop())
        }
        return () => {
        };
    }, [searchData]);



    React.useEffect(() => {
        clearStops()
        return () => {
        };
    }, [flightData]);



    const checkNonstop = (flightData) => {
        return flightData?.flightListData?.some(flight =>
            flight?.slice_data?.some(slice =>
                slice?.flight_data?.length === 1
            )
        ) ?? false;
    }



    const filterStops = (index) => {
        setStops((prevState) => {
            const newValues = [...prevState];
            newValues[index].show = !newValues[index].show;
            if (index === 0) {
                dispatch(filterByStops(newValues[index].value));
            }
            else {
                dispatch(filterByStops(newValues[index].value));
            }


            let onlyNonstop = true;
            newValues.forEach((value, valueIndex) => {
                if (valueIndex !== 0) {
                    if (value.show) {
                        onlyNonstop = false;
                    }
                }
                else {
                    if (value.show) {
                        onlyNonstop = true;
                    }
                    else {
                        onlyNonstop = false;
                    }
                }
            })

            if (onlyNonstop) {
                setNonStop(true)
            } else {
                setNonStop(false)
            }

            return newValues;
        })
    }


    const filterNonStop = () => {
        if (!selectNonStop) {
            selectNonstop()
        }
        else {
            clearStops()

        }
    }



    const selectNonstop = () => {
        setStops((prevState) => {
            const newValues = [...prevState];
            newValues[0].show = true;
            newValues[1].show = false;
            newValues[2].show = false;
            return newValues;
        })
        dispatch(filterByNonStop())
        setNonStop(true)


    }
    const clearStops = () => {
        dispatch(clearNonStop())
        setNonStop(false)
        setStops(initalStops);
    }

    const selectedClass = useSelector(state => state.Flights.flightData.cabinClass);
    const flightType = ['Cheapest', 'Best', 'Quickest', 'Earliest'];
    const flightClass = [{ name: 'Economy', value: 'economy' },
    { name: 'Premium Economy', value: 'premium' }, { name: 'Business', value: 'business' },
    { name: 'First', value: 'first' }];

    const dispatch = useDispatch();

    const selectType = (value) => {
        setType(value)
        dispatch(sortFlightList(value));
    }


    const selectClass = async (value) => {
        await dispatch(updateFlightDataItem({ type: 'class', value: value }))
        dispatch(resetFlightPage())
        dispatch(getFlightsListThunk())
    }



    return (
        <div style={{
            backgroundColor: "#FFFFFF",
            position: "sticky",
            height: "auto",
            top: 45, paddingTop: 20,
            paddingBottom: 20,
            zIndex: 2
        }}>


            <FlightsFilter filterStops={filterStops} stops={stops} clearStops={clearStops} />





            <Menu pointing secondary style={{
                marginTop: 20,
                borderBottom: "10px solid var(--lightGrayF)",

                paddingLeft: is_mobile ? 0 : '22%',
                width: is_mobile ? "78%" : "100%",
                position: 'relative', // important for anchoring the absolute child
            }}>

                {flightType.map((type, index) => {
                    return (
                        <div key={index}
                            style={{
                                letterSpacing: "0",
                                backgroundColor: "initial",
                                opacity: "1",
                                textAlign: "center",
                                height: 40,
                                width: "110px",
                                paddingTop: "0px",
                                paddingLeft: is_mobile ? 0 : "15px",
                                paddingRight: "15px",
                                color: selectedType === type ? "#19BC9B" : '#000000',
                                borderBottom: selectedType === type ? '10px solid #19BC9B' : '10px solid var(--lightGrayF)',
                                marginBottom: -48,
                                marginRight: is_mobile ? 0 : 40,
                                marginLeft: is_mobile ? -15 : 0,
                                cursor: "pointer",

                            }}
                            onClick={() => selectType(type)}>
                            <p style={{ verticalAlign: "middle", font: "18px/18px Futura Md BT" }}>{type}</p>
                        </div>
                    )

                })}


            </Menu>

            <div>

                {!is_mobile && (
                    <div
                        style={{
                            position: 'absolute',
                            right: 0,
                            top: 50,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            opacity: hasNonStop ? "1" : '0.2',
                            cursor: "pointer",
                        }}
                        onClick={hasNonStop ? filterNonStop : null}
                    >
                        <NonStopCheckBox label={stops[0].name} checked={selectNonStop} />
                    </div>
                )}
            </div>

            <Menu secondary style={{
                marginTop: 10,
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                borderBottom: 'none',
                paddingLeft: 0,
                width: is_mobile ? "100%" : "100%"
            }}>
                {flightClass.map((classType, index) => (
                    <div
                        key={index}
                        style={{
                            letterSpacing: "0",
                            font: is_mobile ? "14px/14px Futura Md BT" : "16px/16px Futura Md BT",
                            color: selectedClass === classType.value ? "#19BC9B" : '#7F7F7F',
                            cursor: "pointer",
                            textAlign: "center",
                            padding: '8px 12px',
                            minWidth: '100px',
                        }}
                        onClick={() => selectClass(classType.value)}
                    >
                        {classType.name}
                    </div>
                ))}
            </Menu>


            {is_mobile && <div
                style={{
                    letterSpacing: "0",
                    backgroundColor: "initial",
                    opacity: hasNonStop ? "1" : '0.2',
                    textAlign: "right",
                    height: 40,
                    width: "100%",
                    marginTop: 10,
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    marginBottom: 0,
                    marginRight: 40,
                    cursor: "pointer",
                }}
                onClick={hasNonStop ? filterNonStop : null}>
                <NonStopCheckBox label={stops[0].name} checked={selectNonStop} />
            </div>}

        </div>
    )
}


export const NonStopCheckBox = ({ label, checked }) => {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    icon={<CheckBoxOutlineBlankOutlined style={{ font: '22px/22px Futura Hv BT', marginTop: -5, color: '#000000' }} />}
                    checkedIcon={<CheckBoxOutlined style={{ font: '22px/22px Futura Hv BT', marginTop: -5, color: '#000000' }} />}
                    name={label}
                />
            }
            style={{ display: 'block', marginBottom: -5 }}
            label={<span style={{ font: "18px/18px Futura Md BT", color: '#000000' }}>
                {label}
            </span>}
        />
    )
}
